import { roleType } from '../interfaces/interfaces';

type roleProp = {
  hcp: roleType;
  patient: roleType;
  reset: roleType;
  anon: roleType;
};

export const role: roleProp = {
  hcp: 'hcp',
  patient: 'patient',
  reset: 'reset',
  anon: 'anon',
};

export type modalClassesProps =
  | 'modal-materials'
  | 'modal-survey'
  | 'modal-survey-patient'
  | 'modal-survey-srd'
  | 'modal-gate'
  | 'modal-iframe'
  | 'modal-gate-hcp'
  | 'modal-gate-patient'
  | 'modal-chat-bot'
  | 'modal-adverse-event-indicate'
  | 'modal-adverse-event-confirm'
  | 'modal-brightcove-video'
  | 'modal-materials-hcp'
  | 'modal-materials-patient'
  | 'modal-language-switcher'
  | 'modal-gate-multi-country-hcp'
  | 'modal-barcode'
  | 'modal-onetime'
  | 'modal-grv-restricted-status';

interface modalProps {
  materials: modalClassesProps;
  exitSurvey: modalClassesProps;
  exitSurveyPatient: modalClassesProps;
  surveySrd: modalClassesProps;
  gate: modalClassesProps;
  iframe: modalClassesProps;
  gateHcp: modalClassesProps;
  gatePatient: modalClassesProps;
  chatBot: modalClassesProps;
  adverseEventIndicate: modalClassesProps;
  adverseEventConfirm: modalClassesProps;
  brightcoveVideo: modalClassesProps;
  modalMaterialsHcp: modalClassesProps;
  modalMaterialsPatient: modalClassesProps;
  modalLanguageSwitcher: modalClassesProps;
  modalGateMultiCountryHcp: modalClassesProps;
  modalBarcode: modalClassesProps;
  modalOneTime: modalClassesProps;
  modalGrvRestrictedStatus: modalClassesProps;
}

export const modalClassNames: modalProps = {
  materials: 'modal-materials',
  exitSurvey: 'modal-survey',
  exitSurveyPatient: 'modal-survey-patient',
  surveySrd: 'modal-survey-srd',
  gate: 'modal-gate',
  iframe: 'modal-iframe',
  gateHcp: 'modal-gate-hcp',
  gatePatient: 'modal-gate-patient',
  chatBot: 'modal-chat-bot',
  adverseEventIndicate: 'modal-adverse-event-indicate',
  adverseEventConfirm: 'modal-adverse-event-confirm',
  brightcoveVideo: 'modal-brightcove-video',
  modalMaterialsHcp: 'modal-materials-hcp',
  modalMaterialsPatient: 'modal-materials-patient',
  modalLanguageSwitcher: 'modal-language-switcher',
  modalGateMultiCountryHcp: 'modal-gate-multi-country-hcp',
  modalBarcode: 'modal-barcode',
  modalOneTime: 'modal-onetime',
  modalGrvRestrictedStatus: 'modal-grv-restricted-status',
};

export const breakpoints = { mdUp: '(min-width: 768px)', mobile: '(max-width: 767px)' };

export const modalClassesList: modalClassesProps[] = [
  modalClassNames.materials,
  modalClassNames.exitSurvey,
  modalClassNames.exitSurveyPatient,
  modalClassNames.gate,
  modalClassNames.iframe,
  modalClassNames.gateHcp,
  modalClassNames.gatePatient,
  modalClassNames.chatBot,
  modalClassNames.adverseEventIndicate,
  modalClassNames.adverseEventConfirm,
  modalClassNames.brightcoveVideo,
  modalClassNames.modalMaterialsHcp,
  modalClassNames.modalMaterialsPatient,
  modalClassNames.modalLanguageSwitcher,
  modalClassNames.modalGateMultiCountryHcp,
  modalClassNames.modalBarcode,
  modalClassNames.modalOneTime,
  modalClassNames.modalGrvRestrictedStatus,
];

export const RESOURCE_CATEGORY = 'resource';

export const PRINT_HIDDEN_CLASS_NAME = 'pmi-print-hidden';

export const ADVERSE_EVENT_URL_PARAM = 'advertEventParam';

export const NOLINK_URL = '<nolink>';

export const PMI_COUNTRY_STORAGE_NAME = 'pmiCountry';

export const PMI_COUNTRY_URL_PARAMETER_NAME = 'country';

export const PMI_COUNTRY_ENDPOINT_URL_PARAMETER_NAME = 'field_grace_product_report_name';

export const PMI_COUNTRY_CODE_DEFAULT = 'AE';

export const EXCLUDE_EXTERNAL_LINK_ICON_CLASS_NAME = 'exclude-external-link-icon';

export const MULTI_COUNTRY_URL_PARAMETER_NAME = 'multiCountry';
export const MULTI_COUNTRY_STORAGE_NAME = 'pmi_multi_country';

export const TRIANGLE_SYMBOL_CLASS_NAME: string = 'pmi-triangle-symbol';

export const PMI_MULTI_COUNTRY_CUSTOMER_TARGET_CLASS_NAME =
  'pmi-multi-country-set-customer-country-param';

export const PMI_MULTI_COUNTRY_CUSTOMER_COUNTRY_LOV_PARAM = 'customer_country_lov';

export const PMI_BARCODE_LOCAL_STORAGE_NAME = 'pmiProductBarcode';

export const PMI_GRV_LOCAL_STORAGE_NAME = 'pfizerGrvProfile';
export const PMI_GRV_RESTRICTED_DATA_LOCAL_STORAGE_NAME = 'pmi_restirced_data';
export const PMI_GRV_CURRENT_USER_DATA_LOCAL_STORAGE_NAME = 'pmi_grv_current_user_data';

export const PMI_ONETIME_LOCAL_STORAGE_NAME = 'pmi_one_time_login';
export const PMI_ONETIME_HOURS_LIMIT = 24;

export const PMI_SEARCH_PRODUCT_UUID_URL_PARAM = 'product_uuid';
export const PMI_SEARCH_KEYWORD_URL_PARAM = 'keyword';
export const PMI_SEARCH_PRODUCT_NAME_URL_PARAM = 'product_name';
export const EXIT_SURVEY_SESSION_NAME: string = 'exitSurveyPopupInteracted';
export const EXIT_SURVEY_COOKIE_NAME: string = 'exitSurveyPopupInteracted';
export const SRD_SURVEY_SESSION_NAME: string = 'srdSurveyPopupInteracted';
export const SRD_SURVEY_COOKIE_NAME: string = 'srdSurveyPopupInteracted';
export const DEEP_LINK_COOKIE_NAME: string = 'pmiDeepLinkInfo';
export const SUBROLE_LOCASTORAGE_NAME: string = 'pmiSubrole';
export const FOOTER_FEEDBACK_EXIST_BODY_CLASS_NAME: string = 'pmi-footer-feedback-btn-exist';
export const PARENT_TAB_INDEX_ATTRIBUTE: string = 'parent-tab-index';
export const NO_DATA_TOKEN: string = '{{noData}}';
